import { BehaviorSubject } from 'rxjs';

export class TableContent {

    public tableCols: any[];
    public tableData: BehaviorSubject<any> = new BehaviorSubject(null);
    public displayedCols: string[] = [];
    public uniqueKey: string;
    public expandedColumn: string[] = [];
    public tableChildCols: any[] = [];
    constructor() {
    }

}
